import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/gruh-udhyog/product-orders";

export const Route = createFileRoute(
  "/admin/_modules/_gruh-udhyog/product-orders"
)({
  component: Page,
});
